define('shared/util/efec/relocator',[
    'shared/lib/RSVP',
    'shared/lib/URI',
    'shared/lib/console',
    'shared/util/Domain',
    'shared/page/city',
    'shared/page/market',
    'shared/page/language'
],
function (
    RSVP,
    URI,
    console,
    Domain,
    getCity,
    getMarket,
    getLanguage
) {
    'use strict';

    var LOG_NAME = 'shared/util/efec/relocator: ';
    var CODE_MADRID = 'md_md';
    var CODE_BARCELONA = 'br_bc';
    var currentDomain;
    var currentEnv;
    var PARAM_CITY = 'city';

    var relocation = {
        englishCenter: {
            'markets': {
                'es': function(currentCityCode, targetCityCode){
                    if (currentCityCode === targetCityCode) {
                        return RSVP.resolve(null);
                    }
                    else if (
                        targetCityCode == CODE_BARCELONA || 
                        targetCityCode == CODE_MADRID
                    ) {
                        var uri = new URI(ret.currentLocation.href);
                        var params = uri.search(true);
                        params[PARAM_CITY] = targetCityCode;
                        uri.search(params);

                        return RSVP.resolve(uri.toString());
                    }
                    else {
                        return getEnglishLiveHomeUrl.apply(this, arguments);
                    }
                }
            },
            'default': function() {
                return RSVP.resolve(null);
            }
        },
        englishLive: {
            'markets': {
                'es': function(currentCityCode, targetCityCode) {
                    if (
                        targetCityCode === CODE_MADRID || 
                        targetCityCode === CODE_BARCELONA
                    ) {
                        return getEnglishCenterHomeUrl.apply(this, arguments);
                    }
                    else {
                        return RSVP.resolve(null);
                    }
                }
            },
            'default': function() {
                return RSVP.resolve(null);
            }
        },
        englishTown: {
            'markets': {},
            default: function(currentCityCode, targetCityCode) {
                if (
                    targetCityCode === CODE_MADRID || 
                    targetCityCode === CODE_BARCELONA
                ) {
                    return getEnglishCenterHomeUrl.apply(this, arguments);
                }
                else {
                    return getEnglishLiveHomeUrl.apply(this, arguments);
                }
            }
        }
    };

    function getEnglishLiveHomeUrl(currentCityCode, targetCityCode, options) {
        var englishLive = new Domain(Domain.ENGLISHLIVE);
        englishLive.set.env(currentEnv);

        return RSVP.resolve(
            '//' + englishLive.toString() + '/' + 
                options.market + '-' + options.language + '/' + 
                '?' + PARAM_CITY + '=' + targetCityCode
        );
    }

    function getEnglishCenterHomeUrl(currentCityCode, targetCityCode) {
        var englishCenter = new Domain(Domain.ENGLISHCENTER);
        englishCenter.set.env(currentEnv);
        return RSVP.resolve(
            '//' + englishCenter.toString() + 
            '/?' + PARAM_CITY + '=' + targetCityCode
        );
    }

    var ret = {
        process: function(targetCityCode) {
            var me = this;
            var site = 'englishCenter';
            var currentMarket;
            var logic;
            var currentCityCode;
            var currentLanguage;

            currentDomain = new Domain(ret.currentLocation.hostname);
            currentEnv = currentDomain.get.env();

            if(currentDomain.is.subOf(Domain.englishCenters)){
                site = 'englishCenter';
            }
            else if(currentDomain.is.subOf(Domain.englishLives)) {
                site = 'englishLive';
            }
            else {
                site = 'englishTown';
            }

            var logicMap = relocation[site];

            return RSVP.resolve()
                .then(function(){
                    return RSVP.all([getMarket(), getCity(), getLanguage()]);
                })
                .then(function(values){
                    currentMarket = values[0];
                    currentCityCode = values[1];
                    currentLanguage = values[2];
                })
                .then(function(){
                    logic =logicMap.markets[currentMarket] || logicMap.default;
                    
                    console.log(LOG_NAME, 
                        currentCityCode,
                        targetCityCode, 
                        ret.currentLocation.hostname, 
                        currentMarket,
                        currentLanguage,
                        currentEnv,
                        site
                    );

                    return logic.call(me, currentCityCode, targetCityCode, {
                        language: currentLanguage,
                        market: currentMarket
                    });
                });
        },
        currentLocation: window.location
    };

    return ret;
});
